import React from "react";
export default function GrepTool({ payload, result }) {
  const inp = payload?.input || {};
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>Pattern</h5>
        <pre className="tool-pre">{inp.pattern || ""}{inp.path ? `  in ${inp.path}` : ""}</pre>
      </div>
      {result && (
        <div className="tool-section">
          <h5>Matches</h5>
          <pre className="tool-pre">{result.content_preview || ""}</pre>
        </div>
      )}
    </div>
  );
}
GrepTool.summarize = (p) => `${p?.input?.pattern || ""}${p?.input?.path ? " " + p.input.path : ""}`;
